<div class="alert-padding">
    <ngb-alert *ngIf="staticAlertOpened === true" [type]="alert.type" (closed)="closeAlert()">{{ alert.message }}
    </ngb-alert>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
  <p style="color: white" > Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>
